"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const toolkit_1 = require("@reduxjs/toolkit");
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const utils_1 = require("../../utils/utils");
const authSlice_1 = require("./authSlice");
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const store_1 = require("../../store");
const input_1 = __importStar(require("../../components/input/input"));
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const screenConstants_1 = require("../../constants/screenConstants");
const analytics_1 = require("../../utils/analytics/analytics");
const ResetPassword = ({ route }) => {
    const { params } = route;
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const navigation = (0, useAppNavigation_1.default)();
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [newPassword1, setNewPassword1] = (0, react_1.useState)('');
    const [newPassword2, setNewPassword2] = (0, react_1.useState)('');
    const performResetPassword = async () => {
        setIsLoading(true);
        const payload = {
            new_password_1: newPassword1.toString(),
            new_password_2: newPassword2.toString(),
            uid: params.uid,
            token: params.token,
        };
        const result = await dispatch((0, authSlice_1.submitResetPassword)(payload));
        logEventWithExtraProperties('api_call', {
            name: 'reset_password',
            status: 'submitted',
            location: 'screen_ResetPassword',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'reset_password',
                status: 'success',
                location: 'screen_ResetPassword',
            });
            setIsLoading(false);
            navigation.navigate(screenConstants_1.SIGN_IN_SCREEN);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'reset_password',
                status: 'fail',
                location: 'screen_ResetPassword',
            });
            setErrors(result.payload);
            setIsLoading(false);
        }
    };
    return (react_1.default.createElement(navContainer_1.default, { isLoading: isLoading, errors: errors, titleText: "Please enter your new password twice.", backArrow: true },
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PASSWORD, placeholder: "New password", setValue: setNewPassword1, error: (0, utils_1.getError)('new_password_1', errors), value: newPassword1 }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PASSWORD, placeholder: "Repeat new password", setValue: setNewPassword2, error: (0, utils_1.getError)('new_password_2', errors), value: newPassword2 }),
        react_1.default.createElement(primaryButton_1.default, { disabled: false, title: "Change password", onPress: performResetPassword, eventName: "change_password" })));
};
exports.default = ResetPassword;
